module.exports = __webpack_public_path__ + "img/clo-model-layer.39bc813e.png";